// Recharts pads the chart by 5px on every side, which the ring would lose.
export const PIE_CHART_DEFAULT_PROPS = {
  margin: { bottom: 0, left: 0, right: 0, top: 0 },
}

// The ring starts at twelve o'clock and runs clockwise.
export const PIE_DEFAULT_PROPS = {
  endAngle: -270,
  innerRadius: '60%',
  outerRadius: '90%',
  startAngle: 90,
  stroke: 'none',
}

// Recharts sorts legend items alphabetically by default.
export const PIE_LEGEND_DEFAULT_PROPS = {
  align: 'right',
  iconSize: 10,
  iconType: 'circle',
  itemSorter: null,
  layout: 'vertical',
  verticalAlign: 'middle',
}

export const PIE_CHART_RADIAN = Math.PI / 180
